import { render, staticRenderFns } from "./contactItem.vue?vue&type=template&id=a5cc494a&scoped=true&"
import script from "./contactItem.vue?vue&type=script&lang=js&"
export * from "./contactItem.vue?vue&type=script&lang=js&"
import style0 from "./contactItem.vue?vue&type=style&index=0&id=a5cc494a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cc494a",
  null
  
)

export default component.exports